var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVext0)",
    fillRule: "evenodd",
    d: "m19.054 8.863l-4.894 5.023a.04.04 0 0 0-.013.03q-.002.013.008.03l.592.93l1.954 3.102q.02.035-.017.017l-3.172-1.542c-.428-.215-.745-.343-.955-.395a2.4 2.4 0 0 0-1.672.202L7.32 17.995q-.065.029-.026-.03l.381-.59l2.177-3.442a.04.04 0 0 0-.004-.043l-1.144-1.162l-5.25-5.4q-.063-.062.021-.042l7.899 2.271c.257.077.527.103.797.077q.257-.02.716-.154q3.839-1.095 7.675-2.194a.01.01 0 0 1 .009.008v.013l-1.517 1.551zm-6.279 1.8q2.45-.831 4.903-1.655c.013 0 .013.009 0 .018l-5.113 3.184a1 1 0 0 1-.75.15a2.2 2.2 0 0 1-.647-.309A616 616 0 0 0 6.381 9.06q-.162-.096.017-.039l5.16 1.753c.257.086.472.12.707.056q.111-.031.51-.172zm5.143-1.522c0-.013-.013-.017-.034-.021a1357 1357 0 0 0-5.1 3.596q-.383.269-.587.312a.98.98 0 0 1-.789-.171Q8.723 10.96 6.034 9.068v.018l4.856 4.757a.04.04 0 0 1 .012.03a.04.04 0 0 1-.008.03L8.138 17.13q-.095.115.022.026a541 541 0 0 0 3.261-2.392a.9.9 0 0 1 .763-.18q.213.044.574.313q1.568 1.159 3.146 2.301q.008 0 .004-.012l-.004-.01l-2.807-3.282a.03.03 0 0 1-.01-.021l.003-.012l.007-.01l4.817-4.705z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVext0",
    x1: 11.999,
    x2: 11.999,
    y1: 7.281,
    y2: 18.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6564FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C40F8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVext);
export default __webpack_public_path__ + "static/media/vext.fdcab922f5b5bc77928cdc725f13ebea.svg";
export { ForwardRef as ReactComponent };